export enum TimeInterval {
  PER_DAY,
  PER_MONTH
}
